// extracted by mini-css-extract-plugin
module.exports = {"icon":"Input_icon__YDV-Y","input":"Input_input__DpepQ","inputError":"Input_inputError__2JRf5"};